import { InboxLayout } from '@/components/Domains/Inbox'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/messaging/_layout')({
  component: InboxLayout,
})
